// extracted by mini-css-extract-plugin
module.exports = {"services":"SocialServices_services__2kf89","textContainer":"SocialServices_textContainer__2H4Dp","text":"SocialServices_text__3dfx4"};